import { enableProdMode } from '@angular/core';
import { resolveConfig } from '@selfai-platform/shared';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

resolveConfig('config.json')
  .then((platform) => platform.bootstrapModule(AppModule))
  .catch((err) => console.error(err));
